import { gql } from '@apollo/client';

export * from './backup.query.generated';

export const BACKUP = gql`
  query backup($backupId: ID!) {
    me: profile {
      id
      role
    }
    backup(backupId: $backupId) {
      id
      status
      storageRegion
      disruptionNotification
      disruptionNotificationGracePeriod
      versionsLimit
      updatedAt
      name
      color
      description
      backupActivity
      creator {
        id
        name
      }
      certificationVerified
      reportsEnabled
      reportsEnabledAt
      activatedAt
      createdAt
      userUpdatedAt
      requiredContentTypes
      pendingActivation
      policy {
        createMembers
        enableReports
        update
        write
        terminate
        backupAssets
        activate
        deferActivation
        manageCredentials
      }
    }
  }
`;
